'use client'

import { BoxProps } from '@chakra-ui/react'
import { ItemApi } from 'appTypes/items'
import { useMemo } from 'react'
import { ParsedPricingInfo } from 'utils/apiUtils/prices'
import { Location } from '@leid/api-locations'
import PeriodsInfo from './PeriodsInfo'

type Props = BoxProps & {
  product: ItemApi
  location?: Location
}

const PeriodInfoDialog = ({ product, location }: Props) => {
  const getPricingInfoForLocation = (location: Location | undefined, pricingInfo: ParsedPricingInfo[] | undefined) => {
    if (!pricingInfo) {
      return undefined
    }

    if (!location) {
      return pricingInfo[0]
    }

    if (location.priceGroupId) {
      const info = pricingInfo.find((s) => s.priceGroupId === location.priceGroupId)
      if (info) {
        return info
      }
    }

    const defaultInfo = pricingInfo.find((s) => s.priceGroupId === undefined)
    if (defaultInfo) {
      return defaultInfo
    }
    return pricingInfo[0]
  }
  const pricingInfo = useMemo(
    () => getPricingInfoForLocation(location, product.pricingInfo),
    [location, product.pricingInfo],
  )

  if (!product.pricingInfo || product.pricingInfo.length === 0) {
    return null
  }
  return <>{pricingInfo && <PeriodsInfo pricingInfo={pricingInfo} />}</>
}

export default PeriodInfoDialog
